import React, { PropsWithChildren } from 'react';

type BlurViewOverlayProps = {
    visible: boolean;
};
const BlurViewOverlay: React.FC<PropsWithChildren<BlurViewOverlayProps>> = ({
    children,
    visible,
}) => {
    if (!visible) {
        return null;
    }
    return (
        <div className="absolute rounded-2xl z-10 bg-[#FFFFFF00] h-full w-full backdrop-blur flex flex-col items-center justify-center">
            {children}
        </div>
    );
};
export default BlurViewOverlay;
